import { defineStore } from 'pinia';
import { nextTick, ref } from 'vue';
// store module
import { ModuleNotification } from '@/stores/moduleConst';
import notificationAPI from '@/apis/other/notificationAPI';
import { MSConstant } from '@/commons/wildcards';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil.js';

export const useNotificationStore = defineStore(ModuleNotification, () => {
  // cần thêm gì thì dev tự thêm vào đây

  const unread = ref(0);

  const tempNotifications = ref([]);

  /** gourp theo nhóm ngày, trước đó */
  function addGroupDate(notifications) {
    const today = new Date();
    notifications.forEach(notification => {
      const createdDate = new Date(notification.created_date);
      if (
        createdDate.getDate() === today.getDate() &&
        createdDate.getMonth() === today.getMonth() &&
        createdDate.getFullYear() === today.getFullYear()
      ) {
        notification.groupDate = MSConstant.GroupDate.Today;
      } else {
        notification.groupDate = MSConstant.GroupDate.Before;
      }
    });
  }

  /** Sort  */
  function sortNotificationsByGroupDate(notifications) {
    notifications.sort((a, b) => a.groupDate - b.groupDate);
  }

  /** Sort theo nhóm Hôm nay, Trước đó */
  function addSortGroupDate(notifications) {
    let sortgroupDate = 0;
    let currentGroupDate = null;
    notifications.forEach((notification, index) => {
      if (notification.groupDate !== currentGroupDate) {
        sortgroupDate = 0;
        currentGroupDate = notification.groupDate;
      }
      notification.sortgroupDate = sortgroupDate++;
    });
  }

  /**
   * Lấy dữ liệu thông báo
   * @param {*} payload
   * @returns
   */
  async function getData(context, payload, isBonus) {
    let res = null;
    let lstOld = context.notifications;

    context.notifications = [];
    context.notificationsGroupDay = [];
    context.notificationsGroupBefore = [];

    if (context.isFetching) return; // Ngăn chặn việc gọi liên tiếp
    context.isFetching = true;
    payload = payload || {};
    payload.filter = this.getFilterPayload(payload);
    try {
      await notificationAPI.getList(payload || {}).then(result => {
        if (result) {
          res = result?.Data || [];
          unread.value = result.Unread || 0;
          context.unread = unread;

          // custom nội dung, các loại thông báo
          this.customNotification(res, context);
          if (isBonus) {
            context.notifications = [...lstOld, ...this.tempNotifications];
          } else {
            context.notifications = this.tempNotifications;
          }

          context.notificationsGroupDay = context.notifications.filter(x => x.groupDate === 0);
          context.notificationsGroupBefore = context.notifications.filter(x => x.groupDate === 1);
        }
      });
    } finally {
      context.isFetching = false; // Reset cờ sau khi hoàn thành tải
    }

    return res;
  }

  /**
   * Custom thông báo
   */
  function customNotification(notifications, context) {
    this.addGroupDate(notifications);

    this.sortNotificationsByGroupDate(notifications);

    this.addSortGroupDate(notifications);

    this.tempNotifications = [];

    notifications.forEach(item => {
      if (item.data) {
        item.targetData = JSON.parse(item.data);

        item.targetData.created_date = item.created_date;
        switch (item.type) {
          case MSConstant.NotificationType.RequestSubmitEstimate: // Yêu cầu nộp dự toán
          case MSConstant.NotificationType.PublishDictionary: //Thông báo lập dự toán
            break;
        }

        this.tempNotifications.push(item);
      }
    });
  }

  /**
   * Thêm thông báo từ socket
   * @param {*} data
   */
  async function pushNotification(context, data) {
    /** Nếu đang show notifi sẽ get data, còn k thấy chỉ lấy số chưa đọc trả cho quả chuông  */
    if (!context && window.ab) {
      context = window.ab;

      await this.getData(context, context.param, false);
    } else {
      let unreadNumber = await this.unreadNotification();
      unread.value = unreadNumber;
    }

    /** Xử lý khi thêm */
    this.processWhenPushSuccess(data, context);
  }

  /**
   * Xử lý sau khi thêm thông báo
   * @param {*} item
   */
  function processWhenPushSuccess(item, context) {
    if (item.data) {
      item.targetData = JSON.parse(item.data);
    }
  }

  /**
   * Lọc thông báo theo loại
   * @returns
   */
  function getFilterPayload(payload) {
    var def = [
      {
        field: 'type',
        operator: MSConstant.FilterOperator.In,
        value: [
          MSConstant.NotificationType.RequestSubmitEstimate, // yêu cầu nộp dự toán
          MSConstant.NotificationType.PublishDictionary, // thông báo ban hành
          MSConstant.NotificationType.Complete, // Hoàn thành
          MSConstant.NotificationType.Reject, // gửi trả
          MSConstant.NotificationType.CancelComplete, // hủy hoàn thành
          MSConstant.NotificationType.RevokeRequest, // yêu cầu thu hồi
          MSConstant.NotificationType.AcceptRevoke, // chấp nhận yêu cầu thu hồi
          MSConstant.NotificationType.SubmitEstimate, // nộp dự toán
          MSConstant.NotificationType.SendSyncTemplates, // thông báo đồng bộ mẫu
          MSConstant.NotificationType.NotiCeilingExpense, // thông báo trần chi
          MSConstant.NotificationType.DeliverAllocation, // thông báo cấp trên giao qđg
          MSConstant.NotificationType.RevokeAllocation, // thông báo cấp trên thu hồi qđg
        ],
      },
    ];

    if (payload?.overrides) {
      payload.overrides = [];
    }
    // Nếu là 0, lấy tất cả. Không cần đk đó
    if (payload?.status && payload?.status != 0) {
      payload?.overrides.push({
        field: 'status',
        operator: MSConstant.FilterOperator.In,
        value: [payload?.status],
      });
    }

    if (payload?.source && payload?.source != 0) {
      payload?.overrides.push({
        field: 'source',
        operator: MSConstant.FilterOperator.In,
        value: [payload?.source],
      });
    }

    let concat = payload?.concat || [];
    let over = payload?.overrides || [];

    concat.forEach(x => {
      let item = def.find(o => o.field == x.field);
      item ? (item.value = item.value.concat(x.value)) : def.push(x);
    });

    over.forEach(x => {
      let index = def.findIndex(o => o.field == x.field);
      index > -1 ? (def[index] = x) : def.push(x);
    });

    return JSON.stringify(def);
  }
  /**
   * Lấy số thông báo chưa đọc
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async function unreadNotification(context) {
    let res = null;
    let payload = {};
    let param = {
      overrides: [],
      status: 1, // chưa đọc tb
    };
    payload.filter = this.getFilterPayload(param);
    try {
      let data = await notificationAPI.getUnread(payload || {});

      res = data?.Unread || 0;
      context.unread = res;
      unread.value = res;
      if (res) {
        var notifications = data?.Data || [];

        var hasUnreadEnact = notifications.some(x => x.type == MSConstant.NotificationType.PublishDictionary);
        var hasUnreadAllocationDelivery = notifications.some(x => x.type == MSConstant.NotificationType.DeliverAllocation);
        // Gộp thông báo: quyết định giao + ban hành => chỉ hiện thông báo quyết định giao
        if (hasUnreadEnact && hasUnreadAllocationDelivery) {
          notifications = notifications.filter(x => x.type != MSConstant.NotificationType.PublishDictionary);
        }

        // Sắp xếp theo thứ tự thời gian, cũ hiện trước, mới hiện sau
        notifications.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));

        // Gán form cho thông báo
        for (var i = 0; i < notifications.length; i++) {
          var item = notifications[i];
          if (item.type == MSConstant.NotificationType.DeliverAllocation) {
            item.form = 'NotificationAllocationReceive';
          }
          else if (item.type == MSConstant.NotificationType.RevokeAllocation) {
            item.form = 'NotificationAllocationRevoke';
          }
          else if (item.type == MSConstant.NotificationType.PublishDictionary) {
            item.form = 'NotificationSyncDictionaryPopup';
          }
          await popupUtil.show(item.form, { data: item, is_enact: hasUnreadEnact });
        }
      }
    } catch (error) { }

    return res;
  }

  /**
   * Show thông báo ban hành
   * @param {*} context
   * @param {*} id
   * @returns
   */
  function showEnactNotification(data) {
    const entity = data.Data.find(x => x.type == MSConstant.NotificationType.PublishDictionary);
    const formatDate = date => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear());
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };
    let enact = [
      {
        value: formatDate(new Date(entity.created_date)),
      },
    ];
    popupUtil.show('NotificationSyncDictionaryPopup', { enact_date: enact });
  }

  /**
   * Cập nhật đã đọc
   * @param {*} context
   * @param {*} id
   * @returns
   */
  async function updateRead(context, item, payload) {
    let res = null;
    let id = item ? item.notification_id : commonFn.generateEmptyUUID();
    try {
      let res = await notificationAPI.updateRead(id);
      if (res) {
        this.updateStatus(context, item, id);
      }
    } catch (error) { }

    return res;
  }

  /**
   * Cập nhật đã đọc ban hành
   * @param {*} context
   * @param {*} id
   * @returns
   */
  async function updateReadEnact() {
    let res = null;
    try {
      res = await notificationAPI.updateReadEnact();
    } catch (error) {
      res = null;
    }
    return res;
  }

  /**
   * Cập nhật đã đọc Nhận quyết định giao
   * @param {*} context
   * @param {*} id
   * @returns
   * NXHinh 13.02.20205
   */
  async function updateReadAllocationDecision() {
    let res = null;
    try {
      res = await notificationAPI.updateReadAllocationDecision();
    } catch (error) {
      res = null;
    }
    return res;
  }

  /** cập nhật trạng thái thông báo đã đọc*/
  function updateStatus(context, item, id) {
    if (id === commonFn.generateEmptyUUID()) {
      context.notifications.forEach(notification => {
        notification.status = MSConstant.NotificationStatus.Read;
      });
    } else {
      // Cập nhật status của thông báo cụ thể
      const notification = context.notifications.find(n => n.notification_id === id);
      if (notification) {
        notification.status = MSConstant.NotificationStatus.Read;
      }
    }

    // Cập nhật số thông báo chưa đọc
    context.unread = item ? context.unread - 1 : 0;

    context.notificationsGroupDay = context.notifications.filter(x => x.groupDate === 0);
    context.notificationsGroupBefore = context.notifications.filter(x => x.groupDate === 1);
  }

  /**
   * Lấy số thông báo trần chi chưa đọc + ID lần nộp trần chi gần nhất
   * vqphong - 19/08/2024
   */
  const getUnreadCeilingExpense = async () => {
    try {
      return await notificationAPI.getUnreadCeilingExpense();
    } catch (err) {
      console.log(err);
    } finally {
      commonFn.unmask();
    }
  };

  /**
   * Đọc toàn bộ thông báo trần chi chưa đọc
   * vqphong - 23/08/2024
   */
  const updateReadCeilingExpense = async () => {
    try {
      return await notificationAPI.updateReadCeilingExpense();
    } catch (err) {
      console.log(err);
    } finally {
      commonFn.unmask();
    }
  };

  return {
    unread,
    tempNotifications,
    addGroupDate,
    sortNotificationsByGroupDate,
    addSortGroupDate,
    getData,
    customNotification,
    pushNotification,
    processWhenPushSuccess,
    getFilterPayload,
    unreadNotification,
    updateRead,
    updateStatus,
    updateReadEnact,
    updateReadAllocationDecision,
    getUnreadCeilingExpense,
    updateReadCeilingExpense,
  };
});
